import { frontendURL } from '../../../helper/URLHelper';
import SettingsWrapper from '../settings/SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/lead-networks'),
      component: () => import('./LeadNetworkLayout.vue'),
      children: [
        {
          path: 'pings',
          name: 'lead_network_pings',
          meta: { permissions: ['administrator', 'agent'] },
          component: () => import('./PingsIndex.vue'),
        },
        {
          path: 'pings/:pingId',
          name: 'lead_network_ping_show',
          meta: { permissions: ['administrator', 'agent'] },
          component: () => import('./PingShow.vue'),
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/lead-networks'),
      component: SettingsWrapper,
      props: { keepAlive: false },
      children: [
        {
          path: '',
          name: 'settings_lead_networks',
          meta: { permissions: ['administrator'] },
          component: () => import('./NetworksSettings.vue'),
        },
        {
          path: ':networkId',
          name: 'settings_lead_network_show',
          meta: { permissions: ['administrator'] },
          component: () => import('./NetworkShow.vue'),
        },
      ],
    },
  ],
};
